import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Card, CardBody, CardHeader } from '@heroui/react';

const TermsOfService = () => {
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 justify-center items-center p-4">
      <Card className="w-full p-8 md:p-12 rounded-lg shadow-2xl max-w-2xl bg-white/95 backdrop-blur-sm">
        <CardHeader className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800">Terms of Service</h2>
        </CardHeader>
        <CardBody>
          <div className="prose max-w-none">
            <ReactMarkdown>
              {`By using our application, you agree to the following terms and conditions. Please read these terms carefully before using our application.

## Acceptance of Terms
By accessing or using our application, you agree to be bound by these terms of service. If you do not agree to these terms, you may not use our application.

## Data
We do not store any of your data locally. All data is processed locally on your device.

## Security
Data sent to LLM's is encrypted using industry-standard encryption protocols.

## Personal Information
Personal information is only used for logging in and logging out. We do not sell your personal information to third parties.

## Disclaimers
Our application is provided *as is* and *as available* without any warranties of any kind, either express or implied. We disclaim all warranties, including, but not limited to:
- The implied warranties of merchantability
- Fitness for a particular purpose
- Non-infringement

## Limitations of Liability
We will not be liable for any damages of any kind arising from the use of our application, including, but not limited to:
- Direct damages
- Indirect damages
- Incidental damages
- Consequential damages
- Punitive damages

## Governing Law
These terms of service will be governed by and construed in accordance with the laws of the State of [Your State], without regard to its conflict of laws principles.

## Changes to Terms
We may modify these terms of service at any time. Your continued use of our application after any such changes constitutes your acceptance of the new terms.`}
            </ReactMarkdown>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default TermsOfService;
